import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AiService } from '../../../../../service/ai.service';

@Component({
    selector: 'app-product-ideas',
    standalone: false,
    templateUrl: './product-ideas.component.html',
    styleUrl: './product-ideas.component.scss'
})
export class ProductIdeasComponent implements OnInit {
    dialog = inject(MatDialogRef<ProductIdeasComponent>);
    data = inject(MAT_DIALOG_DATA);
    aiService = inject(AiService);
    loading: boolean = false;

    ideaList: any[] = [];

    selectedIdea: any;

    async ngOnInit(): Promise<void> {
        this.loading = true;
        let result: any = await this.aiService.getAiStandaloneResponse("GENERATE_PRODUCT_IDEAS", this.data);
        this.loading = false;
        if (result && result.promptResult && Array.isArray(result.promptResult)) {
            this.ideaList = result.promptResult;
        }
        // console.log(this.data);
    }

    close() {
        this.dialog.close();
    }
    selectIdea() {
        this.dialog.close(this.selectedIdea);
    }

    choise(idea: any) {
        this.selectedIdea = idea;
        // console.log('Selected Idea:', this.selectedIdea);

    }
}
